import { Component, computed, inject } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { ThemeService } from './core/services/theme.service';
import { AuthService } from './core/services/auth.service';
import { UnitRouteLoadingService } from './core/services/unit-route-loading.service';
import { UnitRouteLoadingSkeletonComponent } from './layout/components/unit-route-loading-skeleton/unit-route-loading-skeleton.component';
import { filter } from 'rxjs';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, UnitRouteLoadingSkeletonComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'catering-webapp';
  protected authService = inject(AuthService);
  protected unitRouteLoading = inject(UnitRouteLoadingService);
  protected readonly showBootSkeleton = computed(
    () => !this.authService.authInitialized() || this.unitRouteLoading.pending()
  );
  private themeService = inject(ThemeService);
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  constructor() {
    this.router.events
      .pipe(filter((event: any): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe(() => {
        if (typeof window !== 'undefined') {
          window.scrollTo(0, 0);
          document.body.scrollTop = 0;
          document.documentElement.scrollTop = 0;
          setTimeout(() => {
           window.scrollTo(0, 0);
          }, 0);
        }
        // /success and /failure carry the unit as ?routeName= rather than in the
        // path; without this fallback a full reload there (e.g. returning from a
        // payment provider) never loads the unit's theme.
        const routeName =
          this.getRouteParamFromActiveTree('routeName') ??
          this.route.snapshot.queryParamMap.get('routeName');
        if (routeName) {
          this.themeService.initializeTheme(routeName);
        } else {
          // this.themeService.initializeTheme('default'); // fallback
        }
      });
    // this.themeService.initializeTheme();
  }

  private getRouteParamFromActiveTree(param: string): string | null {
    let currentRoute: ActivatedRoute | null = this.route;
    let value: string | null = null;
    while (currentRoute) {
      const candidate = currentRoute.snapshot.paramMap.get(param);
      if (candidate) {
        value = candidate;
      }
      currentRoute = currentRoute.firstChild;
    }

    return value;
  }
}
